import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import AcceptTradingOfferModalHeader from './components/AcceptTradingOfferModalHeader';
import AcceptTradingOfferModalBody from './components/AcceptTradingOfferModalBody';
import AcceptTradingOfferModalFooter from './components/AcceptTradingOfferModalFooter';

import { useAcceptTradingOfferModal } from './context/AcceptTradingOfferModalContext';

const AcceptTradingOfferModal: FC = () => {
  const { data } = useAcceptTradingOfferModal();

  return (
    <>
      <AcceptTradingOfferModalHeader />
      <AcceptTradingOfferModalBody />
      <AcceptTradingOfferModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AcceptTradingOfferModal;
